<template>
  <div class="wrap">
    <CesiumViewer ref="cesiumViewer" />

    <div class="left">
      <EquipmentInfo />
      <EventsCount />
    </div>

    <div class="right">
      <PatrolNumber />
      <EventsTodo />
      <VendorRanking />
    </div>

    <WaterQuality @water-data-ready="onWaterDataReady" />

    <div class="bottom">
      <div style="height: 80%;width: 10rem;color: #fff;display: flex;align-items: center;font-size: 0.8rem;">
        <img src="@/assets/image/parking.png" alt="" style="height: 100%;"><span>泊车问题</span>
        <div style="margin-left: 10px;color: aqua;font-weight: 600;font-size: 1rem;">5处</div>
      </div>
      <div style="height: 80%;width: 10rem;color: #fff;display: flex;align-items: center;font-size: 0.8rem;">
        <img src="@/assets/image/garbage.png" alt="" style="height: 100%;"><span>垃圾处理</span>
        <div style="margin-left: 10px;color: aqua;font-weight: 600;font-size: 1rem;">6处</div>
      </div>
      <div style="height: 80%;width: 10rem;color: #fff;display: flex;align-items: center;font-size: 0.8rem;">
        <img src="@/assets/image/lawn.png" alt="" style="height: 100%;"><span>草坪维护</span>
        <div style="margin-left: 10px;color: aqua;font-weight: 600;font-size: 1rem;">2处</div>
      </div>
      <div style="height: 80%;width: 10rem;color: #fff;display: flex;align-items: center;font-size: 0.8rem;">
        <img src="@/assets/image/manhole-cover.png" alt="" style="height: 100%;">
        <div>井盖问题</div>
        <div style="margin-left: 10px;color: aqua;font-weight: 600;font-size: 1rem;">2处</div>
      </div>
    </div>
  </div>
</template>

<script>
import CesiumViewer from '@/components/CesiumViewer.vue';
import EventsTodo from './components/EventsTodo.vue';
import VendorRanking from './components/VendorRanking.vue';
import EquipmentInfo from './components/EquipmentInfo.vue';
import EventsCount from './components/EventsCount.vue';
import PatrolNumber from "@/page/screen/components/PatrolNumber";
import WaterQuality from './components/WaterQuality.vue';

export default {
  name: "index",
  components: {
    PatrolNumber,
    CesiumViewer,
    EventsTodo,
    VendorRanking,
    EquipmentInfo,
    EventsCount,
    WaterQuality,
  },
  methods: {
    onWaterDataReady(waterData) {
      // 将水质数据通过事件总线传递给地图组件
      this.$emitter.emit('water-data-ready', waterData);
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  :deep(#cesiumContainer) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
  }

  .left {
    background: linear-gradient(to right, #171e21FF, #171e2100);
    width: 25%;
    height: 100%;
    display: flex;
    flex-direction: column;
    z-index: 300;
    position: absolute;
    left: 0;
    top: 0;
    padding: 1rem;
  }

  .right {
    width: 25%;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1rem 1rem 2rem 0;
    z-index: 300;
    background: linear-gradient(to left, #171e21FF, #171e2100);
  }

  .bottom {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 2rem;
    width: 50%;
    background-image: linear-gradient(90deg, rgba(88, 141, 233, 0) 0%, rgba(0, 234, 255, 0.176) 98%);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    z-index: 300;
  }
}
</style>
